import { NavigationRoutesInterface } from 'domain/navigation-routes';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontSize } from 'shared/styles/typography';
import TextBody from '../TextBody/TextBody';
import './Navigation.scss';

interface NavigationInterface {
  routes: NavigationRoutesInterface[];
}

const Navigation = ({ routes }: NavigationInterface) => {
  return (
    <>
      {routes.map(({ label, path, Icon }) => (
        <NavLink key={path} to={path} className="navigation-container__link" activeClassName="navigation-container__active-link">
          {Icon && <Icon />}
          <TextBody component="p" size={FontSize.Medium} style={{ marginLeft: '1rem' }}>
            {label.toUpperCase()}
          </TextBody>
        </NavLink>
      ))}
    </>
  );
};

export default Navigation;
